"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const action_type_1 = __importDefault(require("../const/action-type"));
const initial_1 = __importDefault(require("../store/initial"));
exports.default = (state = initial_1.default.calendar, action) => {
    switch (action.type) {
        case action_type_1.default.SET_CALENDAR:
            return action.data;
        case action_type_1.default.RESET_STORE:
            return initial_1.default.calendar;
        case action_type_1.default.SWITCH_WORKSPACE:
            return initial_1.default.calendar;
        case action_type_1.default.SET_CALENDAR_ROLE_VACATION_FUND: {
            const { id, displayVacationsAsDays, value } = action.data;
            if (!state?.roleStats)
                return state;
            const role = state.roleStats[id];
            const newRole = displayVacationsAsDays
                ? { ...role, yearVacationRemainingDays: value - role.yearVacationDays }
                : { ...role, yearVacationRemainingMinutes: value - role.yearVacationMinutes };
            return {
                ...state,
                roleStats: { ...state.roleStats, [id]: newRole },
            };
        }
        default:
            return state;
    }
};
